import {Injectable} from '@angular/core';
import {StoreConfig} from '@datorama/akita';
import {GridStore} from '@q9elements/ui-kit/components';
import {ImpactGridEntity} from './impact-grid-entity';

@Injectable()
@StoreConfig({name: 'impactGrid', idKey: '_id', resettable: true})
export class ImpactGridStore extends GridStore<ImpactGridEntity> {
  constructor() {
    super({
      sort: [{dir: 'desc', field: 'id'}]
    });
  }
}
